const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SEQUENCE: "/sequence",
};

export default ROUTES;
